import React, {useState} from 'react';
import {Link} from "react-router-dom";
import ReactTable from "react-table";

import {
  Button,
  Card, CardBody,
  CardHeader, Col,
  Container,
  FormSelect,
  Row
} from "shards-react";

export default function ConfigExpenseTypes({expenseTypeList}) {
  const [formData, setFormData] = useState({
    pageSizeOptions: [5, 10, 15, 20, 25, 30],
    pageSize: 5,
  });

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  const {pageSizeOptions, pageSize} = formData;
  const tableData = expenseTypeList;
  const tableColumns = [
    {
      Header: "Expense Type",
      accessor: "expenseType",
      className: "justify-content-start"
    },
    {
      Header: "Ref #",
      accessor: "expenseTypeId",
      className: "text-center",
      maxWidth: 100,
      Cell: row => <Link to={'/sub-edit-expense-type/'+row.original.expenseTypeId}>{row.original.expenseTypeId}</Link>
    }
  ];
  return (
    <div className="mt-5 position-relative">
      <span className="tableHeader">Expense Types</span>
      <Card className="tableCard p-0 border-card">
        <CardHeader className="p-0 pt-2">
          <Container fluid className="file-manager__filters border-bottom">
            <Row>
              {/* Filters :: Page Size */}
              <Col
                className="file-manager__filters__rows d-flex align-items-center col-6">
                <span>Show</span>
                <FormSelect
                  size="sm"
                  name='pageSize'
                  value={pageSize}
                  onChange={onChange}
                >
                  {pageSizeOptions.map((size, idx) => (
                    <option key={idx} value={size}>
                      {size} rows
                    </option>
                  ))}
                </FormSelect>
              </Col>

              <Col
                className="file-manager__filters__search d-flex justify-content-end col-6">
                <Link to="/sub-add-expense-type/0">
                  <Button className="my-2 py-2 mx-2" size='sm'
                          theme="accent">Add Expense Types</Button>
                </Link>
              </Col>
            </Row>
          </Container>
        </CardHeader>
        <CardBody className="p-0">
          <div className="">
            <ReactTable
              columns={tableColumns}
              data={tableData}
              pageSize={Number(pageSize)}
              showPageSizeOptions={false}
              resizable={false}
              noDataText="No results found"
            />
          </div>
        </CardBody>
      </Card>
    </div>
  )
}
